<template>
  <el-dialog :title="$t('i18n.4b149ff3b4fc4adbb72cf827ba14835d')" :visible.sync="dialogVisible" width="800px">
    <div v-load="loading">
      <div style="margin-bottom: 15px">
        <span>{{ $t('922') }}：</span>
        <span style="margin-right: 15px">{{ baseData.operator }}</span>
        <span>{{ $t('new_operation_time') }}：</span>
        <span>{{ baseData.operatorTime }}</span>
      </div>
      <el-table :data="baseData.items">
        <el-table-column prop="field" :label="$t('i18n.ee27167d0699487a805c67c594c8b43b')"></el-table-column>
        <el-table-column prop="before" :label="$t('i18n.ff897c7e89c8488985ba2f9778344d2e')">
          <template slot-scope="scope">
            <span v-html="scope.row.before"></span>
          </template>
        </el-table-column>
        <el-table-column prop="after" :label="$t('i18n.8ce335b47e3742d89c321a09e310f7a2')">
          <template slot-scope="scope">
            <span v-html="scope.row.after"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('66') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      baseData: {}
    }
  },
  methods: {
    init(id) {
      this.dialogVisible = true
      this.loading = true
      this.baseData = {}
      this.$http({
        url: `/web/operate_record/showDetails?id=${id}`
      })
        .then(res => {
          this.baseData = res.data || {}
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
